import styles from './TermsOfServicePageMobile.module.less'
import { useEffect, useRef, useState } from 'react'
import cls from 'classnames'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import { Spin } from 'antd'
import { ORDER_ICONS } from '@/pages/PrivacyPage/PrivacyPage'
import { INTERNAL_HOST } from '@/commonConst'
// 预加载两个 markdown 文件
const loadMarkdownZh = () => import('@/docs/Terms_of_Service_Adeff_zh.md')
const loadMarkdownEn = () => import('@/docs/Terms_of_Service_Adeff.md')


function TermsOfServicePageMobile() {
  const [md, setMd] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const index = useRef(0)
  const isInternal = INTERNAL_HOST.includes(location.hostname)

  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        const loadFn = isInternal ? loadMarkdownZh : loadMarkdownEn
        const file = await loadFn()
        const res = await fetch(file.default)
        const content = await res.text()
        /** 下载下来的 doc 读出来 ' ' 是编码形式的，影响了页面分隔字符的样式，这里手动替换 */
        setMd(content.replace(/\u00A0/g, ' '))
      } catch (error) {
        console.error('Failed to load markdown:', error)
      } finally {
        setLoading(false)
      }
    }

    loadMarkdown()
  }, [])

  return (
    <div className={cls(styles.termsOfServicePage)} data-testid='terms-of-service-page'>
      <div className={styles.termsOfServicePageContent}>
        {
          isInternal
            ? <p className={styles.title}>《AdEff用户协议》</p>
            : <p className={styles.title}>Terms of Service-AdEff</p>
        }
        <div className={cls(styles.content, styles.markdownBody)}>
          {loading && (
            <div className={styles.loading}>
              <Spin />
            </div>
          )}
          {!loading && (
            <Markdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
              components={{
                h1: ({ children }) => {
                  index.current++
                  return (
                    <h1 className={styles.h1}>
                      <img className={styles.orderIcon} src={ORDER_ICONS[index.current]} />
                      {children}
                    </h1>
                  )
                },
              }}
            >
              {md}
            </Markdown>
          )}
        </div>
      </div>
    </div>
  )
}

export default TermsOfServicePageMobile
